import React, { useEffect, useState } from "react";
import { useLanguage } from "./LanguageContext";
import Wrapper from "./components/Wrapper";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Faq from "./components/Faq";
import Divider from "./components/Divider";
import CreditCalculator from "./components/CreditCalculator";
import History from "./components/History";
import ShortDivider from "./components/ShortDivider";
import Documents from "./components/Documents";
import Warning from "./components/Warning";
import Terms from "./components/Terms";
import Advantages from "./components/Advantages";
import Video from "./components/Video";
import Main from "./components/Main";
import HighInterestModal from "./components/HighInterestModal";
import About from "./components/About";
import axios from "axios";

function App() {
    const { language } = useLanguage();
    const [showModal, setShowModal] = useState(true);
    const [appLinks, setAppLinks] = useState(null);
    const [appMedia, setAppMedia] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.body.setAttribute("data-language", language);
    }, [language]);

    useEffect(() => {
        axios.get('https://cosmo.run.am/api.php?action=getAppData')
            .then(response => {
                setAppLinks(response?.data?.app_links);
                setAppMedia(response?.data?.app_media)
            })
            .catch(error => {
                console.error('Error fetching app links:', error);
            })
            .finally(() => {
                setLoading(false); // Always stop loading
            });
    }, [])

    if (loading) {
        return null;
    }

    const handleCloseModal = () => setShowModal(false);

    return (
        <>
            {showModal && <HighInterestModal onClose={handleCloseModal} />}
            <Navigation />
            <Main appMedia={appMedia} />
            <Wrapper>
                <Divider mainId="about" />
                <About appLinks={appLinks} />
                <Divider />
                <Video appMedia={appMedia} />
                <Divider mainId="advantages" />
                <Advantages />
                <Divider mainId="terms" />
                <Terms />
                <Warning />
                <Documents />
                <ShortDivider />
                <History />
                <Divider mainId="calculator" />
                <CreditCalculator appLinks={appLinks} />
                <Divider mainId="faq" />
                <Faq />
            </Wrapper>
            <Footer appLinks={appLinks}/>
        </>
    );
}

export default App;
